import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  Button,
  Header,
  Label,
  Loader,
  Grid,
  Icon,
  Confirm,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { history } from '../../helpers';
import { termActions } from '../../actions/term.actions';
import { userConstants } from '../../constants/user.constants';

class TermsIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmOpen: false,
      confirmTerm: null,
      confirmMessage: null,
    };

    this.goToCreate = this.goToCreate.bind(this);
  }

  static get propTypes() {
    return {
      terms: PropTypes.any,
      me: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.fetchTerms();
  }

  fetchTerms() {
    const { dispatch } = this.props;
    dispatch(termActions.fetch());
  }

  showConfirm(term) {
    this.setState({
      confirmOpen: true,
      confirmTerm: term,
      confirmMessage: `Tem certeza que deseja remover o termo "${term.Title}" (v${term.Version})?`,
    });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false });
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmTerm } = this.state;
    dispatch(termActions.remove(confirmTerm.Id)).then(() => this.fetchTerms());
    this.setState({ confirmOpen: false, confirmTerm: null, confirmMessage: null });
  }

  goToCreate() {
    history.push('/settings/terms/create');
  }

  render() {
    const { terms, loading, me } = this.props;

    // Check Permission
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    return (
      <Fragment>
        <Loader active={loading}>Carregando...</Loader>
        <Confirm
          open={this.state.confirmOpen}
          content={this.state.confirmMessage}
          cancelButton='Cancelar'
          confirmButton='Remover'
          onCancel={() => this.closeConfirm()}
          onConfirm={() => this.executeConfirm()}
        />
        <Header>
          <h1>Termos de Uso</h1>
        </Header>

        <Grid stackable columns='2'>
          <Grid.Row>
            <Grid.Column textAlign='left' width={12}>
              Documentos de termo de uso apresentados aos usuários nas estações de trabalho. A versão ativa é exigida no logon até que o usuário a aceite.
            </Grid.Column>
            <Grid.Column textAlign='right' width={4}>
              <Button color='primary' fluid onClick={this.goToCreate}>Novo Termo</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Card.Group style={{ marginTop: '8px' }}>
          { (!terms || terms.length == 0) &&
            <Card header='Nenhum termo cadastrado' fluid />
          }

          { terms && terms.map((term) => {
            return <Card key={term.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {term.Title}
                  <Label style={{ float: "right", marginRight: '4px' }} color={term.Active ? 'green' : 'grey'}>
                    {term.Active ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Meta>Versão {term.Version} &middot; criado em {moment(term.CreatedAt).format('DD/MM/YYYY HH:mm')}</Card.Meta>
              </Card.Content>
              <Card.Content extra>
                <Button size='mini' secondary icon onClick={() => history.push(`/settings/terms/update/${term.Id}`)}>
                  <Icon name='edit' />
                  Alterar
                </Button>
                <Button size='mini' color='red' icon onClick={() => this.showConfirm(term)}>
                  <Icon name='cancel' />
                  Excluir
                </Button>
              </Card.Content>
            </Card>
          }) }
        </Card.Group>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { term, users } = state;

  return {
    terms: term.list || null,
    loading: term.loading,
    me: users.me || null,
  };
}

const connectedTermsIndexScreen = connect(mapStateToProps)(TermsIndexScreen);
export { connectedTermsIndexScreen as TermsIndexScreen };
